"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    assetBoxWrapper: {
      background: theme.palette.background.paper,
      borderRadius: "4px",
      boxShadow: "0 0 4px rgba(0, 0, 0, 0.5) inset",
      overflow: "hidden"
    },
    assetDiv: _objectSpread(_objectSpread({}, theme.scrollbars.main), {}, {
      maxHeight: "465px",
      padding: theme.spacing(2, 0),
      overflow: "auto",
      textAlign: "center"
    }),
    assetLabel: {
      display: "block",
      fontSize: ".75rem",
      fontWeight: "bold",
      marginBottom: 8,
      marginTop: 16,
      position: "static",
      transform: "none"
    },
    fieldWrapper: {
      margin: "0.5rem 0 1.5rem"
    },
    buttonCorrections: {
      border: "2px solid transparent",
      borderRadius: "6px",
      transition: theme.transitions.create(["border", "opacity"]),
      width: "calc(100% - 2px)",
      "&:hover, &:focus": {
        opacity: ".85"
      }
    },
    selectedCard: {
      border: "2px solid " + theme.palette.primary.main
    },
    selectedItemCheckbox: {
      height: "64px",
      left: "0",
      overflow: "hidden",
      position: "absolute",
      top: "0",
      width: "64px",
      zIndex: "1"
    },
    selectedItemCheckboxBackground: {
      alignItems: "center",
      background: theme.palette.primary.main,
      display: "flex",
      height: "86px",
      justifyContent: "flex-end",
      left: "-43px",
      position: "absolute",
      top: "-43px",
      transform: "rotate(45deg)",
      width: "86px"
    },
    selectedItemCheckboxIcon: {
      color: theme.palette.primary.contrastText,
      transform: "rotate(-45deg)",
      marginRight: "4px",
      marginTop: "-2px"
    },
    selectAssetsModalHeader: {
      marginBottom: theme.spacing(2)
    },
    selectAssetsModalSearch: {
      display: "flex"
    },
    selectAssetsModalFilterInput: {
      width: "100%",
      marginRight: "10px"
    },
    selectAssetsModalFilterIcon: {
      margin: "5px 0"
    },
    selectAssetModalSortSection: {
      margin: "0 20px"
    },
    uploadAssetsUploadWrapper: {
      display: "flex",
      flexGrow: "1",
      margin: "1rem 0"
    },
    selectedAssets: {
      margin: "8px 0 0",
      "& > div": {
        display: "inline-block",
        margin: "4px",
        maxWidth: "210px",
        width: "45%"
      },
      "& > div:first-child:last-child, & > div:nth-child(odd):last-child": {
        width: "100%"
      },
      "&:empty": {
        margin: "0"
      }
    }
  };
};

exports.styles = styles;